import sndRoutes from './sub-modules/snd/routes.js'
import teacherRoutes from './sub-modules/teacher/routes.js'
import parentsRoutes from './sub-modules/parents/routes.js'

export default [...sndRoutes, ...teacherRoutes, ...parentsRoutes]
